import { render, staticRenderFns } from "./OrderCancel.vue?vue&type=template&id=350e682f&lang=pug&"
import script from "./OrderCancel.vue?vue&type=script&lang=ts&"
export * from "./OrderCancel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports